export const DARK_BOARD_GREEN_HEX = '#031a14';
